// Ordered from Aurora_Basic_Political_Descriptors2.xlsx (priority A-E, then row order) order requested by Ray.
const orderedSegmentIds = [
    "VBR1", "VBR2", "VBR3", "VBR4", "VBR5", "VBR6", "VBR7",
    "VOTER_CTV", "VOTER_EMAIL", "VOTER_LINEAR_TV", "VOTER_MOBILE_APP", "VOTER_NEWSITES_RADIO", "VOTER_SOCIAL_MEDIA",
    "VOTER_EDU_HIGHSCHOOL", "VOTER_EDU_COLLEGEGRAD", "VOTER_EDU_ADVDGREE",
    "VOTER_DAS_LOW_INTEREST", "VOTER_DAS_STUDENTS_YPRO", "VOTER_DAS_BUSINESSOWNER", "VOTER_UNION", "VOTER_TEACHER_SOCIALWRK", "VOTER_CORPEXEC", "VOTER_GIGWORKER", "VOTER_PROFWOMAN", "VOTER_PROFSERV_ACCT_LEGAL_HCP", "VOTER_SECURITY_MOM", "VOTER_HEALTHCAREWORKERS", "VOTER_VETERANS", "VOTER_MILITARY", "VOTER_GOVERNMENT_1", "VOTER_PRE_RETIREE", "VOTER_RETIREE",
    "VSG011", "VSG1223", "VSG2435", "VSD6576", "VSD89100",
    "VOTER_GLOBAL_WARMING_CONCERN", "VOTER_CRIME_CONCERNS", "VOTER_GUN_CONTROL", "VOTER_GUN_RIGHTS", "VOTER_PRO_CHOICE", "VOTER_ANTI_ABORTION", "VOTER_BORDER_SECURITY", "VOTER_IMMIGRATION_RIGHTS", "VOTER_ECONOMY_ISOLATIONIST", "VOTER_OPEN_ECONOMY", "VOTER_TAX_RELIEF", "VOTER_TAX_RICH", "VOTER_INFLATION_DEM_FAULT", "VOTER_INFLATION_GOP_FAULT", "VOTER_LIMIT_MEDICARE_MEDICAID", "VOTER_SAVE_MEDICARE_MEDICAID", "VOTER_VOTER_RIGHTS", "VOTER_SOCIAL_CONSERVATIVE", "VOTER_SOCIAL_LIBERAL",
    "VBPAV", "VSF", "VSN", "VSS", "VSU", "VSI",
    "REG_VOTER_DAS_ABOVE_AVG", "REG_VOTER_DAS_AVG", "REG_VOTER_DAS_BELOW_AVG", "REG_VOTER_DAS_LEAST", "REG_VOTER_DAS_MOST_ACTIVE",
    "VBRC1", "VBRC2", "VBRC3", "VBRC4", "VBRC5", "VBRC6",
    "VBREPD", "VBCOND", "VBCONHD", "VBCONRD", "VBDEMD", "VBLIBHD", "VBLIBRD",
    "VBMDHVD1", "VBMDHVD2", "VBMDHVD3", "VBMDHVD4", "VBMDHVD5",
    "VBMDRPTD1", "VBMDRPTD2", "VBMDRPTD3", "VBMDRPTD4", "VBMOD",
    "VBMRHVD1", "VBMRHVD2", "VBMRHVD3", "VBMRHVD4", "VBMRHVD5",
    "VBMRRPTD1", "VBMRRPTD2", "VBMRRPTD3", "VBMRRPTD4",
    "VBMUHVD1", "VBMUHVD2", "VBMUHVD3", "VBMUHVD4", "VBMUHVD5",
    "VBMURPTD1", "VBMURPTD2", "VBMURPTD3", "VBMURPTD4",
    "VBPCHD", "VBPFFD", "VBPGD", "VBPGLBTD", "VBPLD", "VBPLIF", "VBPROD", "VBPV",
];

const segmentOrder = new Map(orderedSegmentIds.map((segmentId, index) => [segmentId, index]));
const fallbackOrder = Number.MAX_SAFE_INTEGER;
const blockEndIndexes = [6, 12, 31, 36, 55, 61, 66, 72, orderedSegmentIds.length - 1];

const getSegmentOrder = ({segment_id}) => segmentOrder.get(segment_id) ?? fallbackOrder;

export const getSemcastingPoliticsOrder = (segmentId) => segmentOrder.get(segmentId) ?? fallbackOrder;

const compareSegments = (first, second) =>
    getSegmentOrder(first) - getSegmentOrder(second) || first.text.localeCompare(second.text);

export const getSemcastingPoliticsBlock = (segmentId) => {
    const segmentIndex = segmentOrder.get(segmentId);
    return segmentIndex === undefined
        ? fallbackOrder
        : blockEndIndexes.findIndex((endIndex) => segmentIndex <= endIndex);
};

export const sortSemcastingPoliticsBlocks = (tree) => {
    const sortItems = (item) => {
        if (item.value === "Semcasting Politics") {
            item.items.sort((first, second) =>
                (first.sortOrder ?? fallbackOrder) - (second.sortOrder ?? fallbackOrder)
            );
        }
        item.items?.forEach(sortItems);
    };
    tree.forEach(sortItems);
    return tree;
};

export const sortSemcastingPoliticsCategories = (groups) => {
    groups.forEach((group) => {
        group.items.forEach((category) => category.items.sort(compareSegments));
        group.items.sort((first, second) =>
            getSegmentOrder(first.items[0]) - getSegmentOrder(second.items[0]) || first.text.localeCompare(second.text)
        );
    });
    return groups;
};
